import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import styles from './Box.module.css.js';
import { Base } from '../../Internal/Base/Base.js';
import clsx from 'clsx';

const styleWideMap = {
    none: styles.noneWide,
    xxs: styles.xxsWide,
    xs: styles.xsWide,
    sm: styles.smWide,
    md: styles.mdWide,
    lg: styles.lgWide,
    xl: styles.xlWide,
    xxl: styles.xxlWide,
};
const Box = ({ children, className, padding = 'md', paddingWide = 'lg', ...restProps }) => {
    const boxClassName = clsx(styles.box, className, styles[padding], styleWideMap[paddingWide]);
    return (jsxRuntimeExports.jsx(Base, { className: boxClassName, ...restProps, children: children }));
};
Box.displayName = 'Box';

export { Box };
//# sourceMappingURL=Box.js.map
